import { createFileRoute } from '@tanstack/react-router';

import { DemandPartnerIntegrationsTable } from '../features/demand/integrations/components/DemandPartnerIntegrationsTable/DemandPartnerIntegrationsTable';

export const Route = createFileRoute('/demand/partners/$demandPartnerId/details/overview')({
  component: DemandPartnerOverviewRoute,
});

function DemandPartnerOverviewRoute() {
  const { demandPartnerId } = Route.useParams();
  return <DemandPartnerIntegrationsTable demandPartnerId={demandPartnerId} />;
}
